import { Card, Col, Container, Row } from 'reactstrap'
import { FeatherIcons, Icons } from '../../../utils/Constant'
import FeatherIconCardBody from './FeatherIconCardBody'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs'
import CardHeaderCommon from '../../../CommonElements/CardHeaderCommon/CardHeaderCommon'

const FeatherIconsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FeatherIcons} parent={Icons} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeaderCommon title={FeatherIcons} />
              <FeatherIconCardBody />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default FeatherIconsContainer